// test398
(398 && 0);
